export const TRANSACTION_DETAIL = [
	{
		label: 'TRANSACTION ID',
		text: '0x0cd098333334d9534376d9534376d9534376376ddb90',
	},
	{
		label: 'FROM',
		text: '0x0cs383223234d9534376d9534376d9534376376ddb90',
	},
	{
		label: 'TO (MY WALLET)',
		text: '0x0ca342ad9534d9534376d9534376d9534376376ddb90',
	},
];
